import React, { FunctionComponent } from "react";
import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { Collapsible } from "@multiweb/reactComponents";
import { getPrimaryText } from "@multiweb/reactCore/i18n";
import { IAppState } from "@multiweb/types/react";
import { createUpdateActivityCollapsibleState, createUpdateWorkflowViewAction } from "../../../actions";
import { LOC_PERTINENCE_TO_SETS } from "../../../locKeys";
import { getActivityPanelStateContainer, getSelectedSetId } from "../../../selectors";
import { IPosition, WorkflowEditorProps } from "../../../types";
import { PropertyRowComponent } from "../components";

type PertienceToSetsContainerProps = {
    readonly isOpen: boolean;
    readonly activityId: string;
    readonly selectedSetId: string;
    readonly positions: readonly IPosition[];
    readonly updateActivityPanelState: (isExpanded: boolean) => void;
    readonly updateWorkflowView: (setId: string, selectedActivityId?: string) => void;
    readonly pertinenceToSetsText: string;
} & WorkflowEditorProps;

const PertienceToSetsContainerComponent: FunctionComponent<PertienceToSetsContainerProps> = ({ positions, activityId, selectedSetId, isOpen, updateActivityPanelState, updateWorkflowView, pertinenceToSetsText }) => {
    const handleClick = (setId: string) => {
        if (selectedSetId !== setId)
            updateWorkflowView(setId, activityId);
    };

    return (
        <Collapsible qa="pertience-to-sets-collapsible-section" captionText={pertinenceToSetsText} defaultOpened={isOpen} onExpansionChange={updateActivityPanelState} handleExpansionExternally>
            {positions.map(({ setName, setId }) =>
                <PropertyRowComponent key={setId} onClick={() => handleClick(setId)} value={""} description={setName} />,
            )}
        </Collapsible>
    );
};

type StateProps = Pick<PertienceToSetsContainerProps, "isOpen" | "pertinenceToSetsText" | "selectedSetId">;

const mapStateToProps: MapStateToProps<StateProps, WorkflowEditorProps, IAppState> = (state, { hostKey }) => ({
    isOpen: getActivityPanelStateContainer(state, hostKey, "SETS").isOpen,
    selectedSetId: getSelectedSetId(state, hostKey),
    pertinenceToSetsText: getPrimaryText(state, LOC_PERTINENCE_TO_SETS) ?? "Příslušnost k sadám",
});

type DispatchProps = Pick<PertienceToSetsContainerProps, "updateActivityPanelState" | "updateWorkflowView">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, WorkflowEditorProps> = (dispatch, { hostKey }) => ({
    updateActivityPanelState: (isExpanded) => dispatch(createUpdateActivityCollapsibleState(hostKey, "SETS", isExpanded)),
    updateWorkflowView: (setId, selectedActivityId) => dispatch(createUpdateWorkflowViewAction(hostKey, setId, selectedActivityId)),
});

export const PertienceToSetsContainer = connect(mapStateToProps, mapDispatchToProps)(PertienceToSetsContainerComponent);
